// =====================================================================
// Memory Map Icon Components
// =====================================================================
// Inline SVG-Icons aus der Combsol Memory Map Icon Library (73 Tiles).
// Jedes Icon ist ein 512×512 Tile mit Gradient-Hintergrund + Neon-Grafik.
// Verwendung: <MmIcon id="app-manus-ai" size={32} />
//
// Für die CC-SideNav werden die Icons als kompakte 20×20 Versionen
// mit abgerundeten Ecken dargestellt.
// =====================================================================

import type { CSSProperties } from "react";

interface MmIconProps {
  size?: number;
  style?: CSSProperties;
  className?: string;
}

// Hilfsfunktion: Rendert ein Memory-Map-Icon als <img> aus dem /icons/mm/ Verzeichnis
// (die SVGs wurden beim Build in public/icons/mm/ abgelegt).
export function MmIcon({
  id,
  size = 20,
  style,
  className,
}: MmIconProps & { id: string }) {
  return (
    <img
      src={`/icons/mm/${id}.svg`}
      alt=""
      width={size}
      height={size}
      draggable={false}
      style={{
        borderRadius: Math.round(size * 0.19),
        flexShrink: 0,
        ...style,
      }}
      className={className}
    />
  );
}

// =====================================================================
// Benannte Icon-Komponenten für typsichere Verwendung
// =====================================================================

export const MmManusAi   = (p: MmIconProps) => <MmIcon id="app-manus-ai"    {...p} />;
export const MmAnalytics = (p: MmIconProps) => <MmIcon id="app-analytics"   {...p} />;
export const MmKanban    = (p: MmIconProps) => <MmIcon id="app-kanban"      {...p} />;
export const MmAiBrain   = (p: MmIconProps) => <MmIcon id="app-ai-brain"    {...p} />;
export const MmRoadmap   = (p: MmIconProps) => <MmIcon id="app-roadmap"     {...p} />;
export const MmDocs      = (p: MmIconProps) => <MmIcon id="app-docs"        {...p} />;
export const MmSettings  = (p: MmIconProps) => <MmIcon id="app-settings"    {...p} />;
export const MmCc        = (p: MmIconProps) => <MmIcon id="app-cc"          {...p} />;
export const MmHistory   = (p: MmIconProps) => <MmIcon id="app-history"     {...p} />;
export const MmCloud     = (p: MmIconProps) => <MmIcon id="app-cloud"       {...p} />;
export const MmDatabase  = (p: MmIconProps) => <MmIcon id="app-database"    {...p} />;
export const MmGoals     = (p: MmIconProps) => <MmIcon id="app-goals"       {...p} />;
export const MmGit       = (p: MmIconProps) => <MmIcon id="app-git"         {...p} />;
export const MmTasks     = (p: MmIconProps) => <MmIcon id="app-tasks"       {...p} />;
export const MmWorkflow  = (p: MmIconProps) => <MmIcon id="app-workflow"    {...p} />;
export const MmMilestone = (p: MmIconProps) => <MmIcon id="app-milestone"   {...p} />;
export const MmStatusOk  = (p: MmIconProps) => <MmIcon id="app-status-ok"   {...p} />;
export const MmStatusWarn = (p: MmIconProps) => <MmIcon id="app-status-warn" {...p} />;
export const MmStatusErr = (p: MmIconProps) => <MmIcon id="app-status-error" {...p} />;
export const MmHub       = (p: MmIconProps) => <MmIcon id="app-hub"         {...p} />;
export const MmNotes     = (p: MmIconProps) => <MmIcon id="app-notes"       {...p} />;
export const MmFair      = (p: MmIconProps) => <MmIcon id="app-fair"        {...p} />;
export const MmLiquid    = (p: MmIconProps) => <MmIcon id="app-liquid"      {...p} />;
export const MmBriefing  = (p: MmIconProps) => <MmIcon id="app-briefing"    {...p} />;
export const MmGesamt    = (p: MmIconProps) => <MmIcon id="app-gesamt"      {...p} />;
export const MmBudget    = (p: MmIconProps) => <MmIcon id="app-budget"      {...p} />;
export const MmPeople    = (p: MmIconProps) => <MmIcon id="app-people"      {...p} />;
export const MmCalendar  = (p: MmIconProps) => <MmIcon id="app-calendar"    {...p} />;
export const MmTime      = (p: MmIconProps) => <MmIcon id="app-time"        {...p} />;
